module.exports = "/assets/data/9c6bc16b4153beee38153a2f3d21095e-BS40.data.json";